import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { EditorCatalogKey } from './editor.i18n.js';
import { EDITOR_CATALOG } from './editor.i18n.js';

export type EditorMessageId = `editor:${EditorCatalogKey}`;

const PREFIX_LENGTH = 'editor:'.length;

/** `t()` for the stop-gap `editor:` scope (see `editor.i18n.ts`). */
export function useEditorT(): { t: (id: EditorMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: EditorMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as EditorCatalogKey;
      const raw = EDITOR_CATALOG[locale][key] ?? EDITOR_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
